<template>
	<div class="page-quick-sidebar">
		<div v-if="businessAccount">
			<div class="tab-content">
				<div class="tab-pane active page-quick-sidebar-chat">
					<div class="page-quick-sidebar-chat-users active-business" data-rail-color="#ddd" data-wrapper-class="page-quick-sidebar-list">
						<ul class="media-list list-items">
							<li class="media selected-location">
								<img class="media-object" src="../../metronic_src/theme/assets/global/img/portfolio/600x600/01.jpg" alt="...">
								<div class="media-status" v-if="!activeLocationId">
									<i class="fa fa-circle font-green-jungle"></i>
								</div>
								<div class="media-body">
									<h4 class="media-heading" v-if="!activeLocationId">{{ activeBusinessName }}</h4>
									<h4 class="media-heading" v-else>{{ activeLocationName }}</h4>
									<div class="media-heading-sub" @click="selectMasterAccount()" v-if="activeLocationId">
										<a class="panel-link">Select Master Account</a>
									</div>
									<div class="media-heading-sub" v-else>Master Account Selected</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="padding-box">
				<div class="form-group form-md-line-input form-md-floating-label">
					<input type="text" class="form-control input-sm padding-right-20" id="location_search" v-model="locationSearch.search" :class="{'edited': locationSearch.search.length}">
					<i v-if="locationSearch.search.length" class="fa fa-times clear-icon" @click="clearSearch('location')"></i>
					<label for="location_search">Search All Locations</label>
					<span class="help-block persist">Search by Location Name</span>
				</div>
			</div>
			<loading-screen :show="loadingLocationData && !locationSearchResults.length" :display="'inline'"></loading-screen>
			<!-- <div v-if="!locationSearchResults.length">
				<div class="padding-box" v-if="locationSearchError.length">
					<div class="alert alert-danger">
						<button class="close" data-close="alert" @click="clearSearchError('location')"></button>
					    <span>{{locationSearchError}}</span>
					</div>
				</div>
				<h3 class="list-heading location-panel-heading blue">Recent Locations</h3>
				<div class="tab-content" v-if="locations.length || activeLocation.location_id">
					<div class="tab-pane active page-quick-sidebar-chat scrollable">
						<div class="page-quick-sidebar-chat-users" data-rail-color="#ddd" data-wrapper-class="page-quick-sidebar-list">
							<ul class="media-list list-items">
								<li class="media" v-if="activeLocation && activeLocation.location_id">
									<div class="media-status">
										<i class="fa fa-circle blue"></i>
									</div>
									<div class="media-body">
										<h4 class="media-heading">{{activeLocation.location_name}}</h4>
										<div class="media-heading-sub">{{activeLocation.location_address}}</div>
									</div>
								</li>
								<li class="media" v-for="location in locations" @click="selectLocation(location)">
									<div class="media-body">
										<h4 class="media-heading">{{location.location_name}}</h4>
										<div class="media-heading-sub">{{location.location_address}}</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div v-else class="padding-box">
					<div class="alert alert-info">
                        <span>There aren't any recently used locations. Please search for a location using the search bar above.</span>
                    </div>
				</div>
			</div> -->
			<div v-if="locationSearchResults.length">
				<h3 class="list-heading location-panel-heading blue">Search Results</h3>
				<div class="tab-content">
					<div class="tab-pane active page-quick-sidebar-chat scrollable">
						<div class="page-quick-sidebar-chat-users" data-rail-color="#ddd" data-wrapper-class="page-quick-sidebar-list">
							<ul class="media-list list-items">
								<li class="media" v-for="location in locationSearchResults" @click="setActiveLocation(location)">
									<div class="media-body">
										<h4 class="media-heading">{{location.location_name}}</h4>
										<div class="media-heading-sub">{{location.location_address}}</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				<div class="padding-box" v-if="locationSearchError.length">
					<div class="alert alert-danger">
						<button class="close" data-close="alert" @click="clearSearchError('location')"></button>
					    <span>{{locationSearchError}}</span>
					</div>
				</div>
			</div>
		</div>
		<div v-if="unoappAccount">
			<div v-if="!activeBusinessId || activeBusinessId === 1">
				<div class="tab-content">
					<div class="tab-pane active page-quick-sidebar-chat">
						<div class="page-quick-sidebar-chat-users active-business" data-rail-color="#ddd" data-wrapper-class="page-quick-sidebar-list">
							<ul class="media-list list-items">
								<li class="media selected-location">
									<img class="media-object" src="../assets/img/app/logo-refresh.png" alt="..." v-if="!activeBusinessId || activeBusinessId === 1">
									<img class="media-object" src="../../metronic_src/theme/assets/global/img/portfolio/600x600/01.jpg" alt="..." v-else>
									<div class="media-status" v-if="!activeLocationName">
										<i class="fa fa-circle font-green-jungle"></i>
									</div>
									<div class="media-body" v-if="!activeBusinessId || activeBusinessId === 1">
										<h4 class="media-heading">No Business Selected</h4>
										<div class="media-heading-sub">Select one by searching below</div>
									</div>
									<div class="media-body" v-else>
										<h4 class="media-heading">{{ activeBusinessName }}</h4>
										<div class="media-heading-sub" @click="selectMasterAccount()" v-if="activeLocationName">
											<a class="panel-link">Select Master Account</a>
										</div>
										<div class="media-heading-sub" v-else>Master Account Selected</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div>
					<div class="padding-box">
						<div class="form-group form-md-line-input form-md-floating-label">
							<input type="text" class="form-control input-sm padding-right-20" id="location_search" v-model="businessSearch.search" :class="{'edited': businessSearch.search.length}">
							<i v-if="businessSearch.search.length" class="fa fa-times clear-icon" @click="clearSearch('business')"></i>
							<label for="location_search">Search All Businesses</label>
							<span class="help-block persist">Search by Business Name</span>
						</div>
					</div>
					<loading-screen :show="loadingBusinessData && !businessSearchResults.length" :display="'inline'"></loading-screen>
					<div v-if="businessSearchResults.length">
						<h3 class="list-heading location-panel-heading blue">Search Results</h3>
						<div class="tab-content">
							<div class="tab-pane active page-quick-sidebar-chat scrollable">
								<div class="page-quick-sidebar-chat-users" data-rail-color="#ddd" data-wrapper-class="page-quick-sidebar-list">
									<ul class="media-list list-items">
										<li class="media" v-for="business in businessSearchResults" @click="setActiveBusiness(business)">
											<img class="media-object" src="../../metronic_src/theme/assets/global/img/portfolio/600x600/02.jpg" alt="...">
											<div class="media-body">
												<h4 class="media-heading">{{business.business_name}}</h4>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div v-else>
						<div class="padding-box" v-if="businessSearchError.length">
							<div class="alert alert-danger">
								<button class="close" data-close="alert" @click="clearSearchError('business')"></button>
							    <span>{{businessSearchError}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				<div class="floating-tab-button" @click="selectMasterUNOappAccount()">Select UNOapp Master Account</div>
				<div class="tab-content">
					<div class="tab-pane active page-quick-sidebar-chat">
						<div class="page-quick-sidebar-chat-users active-business" data-rail-color="#ddd" data-wrapper-class="page-quick-sidebar-list">
							<ul class="media-list list-items">
								<li class="media selected-location">
									<img class="media-object" src="../../metronic_src/theme/assets/global/img/portfolio/600x600/01.jpg" alt="...">
									<div class="media-body">
										<h4 class="media-heading" v-if="!activeLocationId">{{ activeBusinessName }}</h4>
										<h4 class="media-heading" v-else>{{ activeLocationName }}</h4>
										<div class="media-heading-sub" @click="selectMasterAccount()" v-if="activeLocationId">
											<a class="panel-link">Select Master Account</a>
										</div>
										<div class="media-heading-sub" v-else>Master Account Selected</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="padding-box">
					<div class="form-group form-md-line-input form-md-floating-label">
						<input type="text" class="form-control input-sm padding-right-20" id="location_search" v-model="locationSearch.search" :class="{'edited': locationSearch.search.length}">
						<i v-if="locationSearch.search.length" class="fa fa-times clear-icon" @click="clearSearch('location')"></i>
						<label for="location_search">Search All Locations</label>
						<span class="help-block persist">Search by Location Name</span>
					</div>
				</div>
				<loading-screen :show="loadingLocationData && !locationSearchResults.length" :display="'inline'"></loading-screen>
				<div v-if="locationSearchResults.length">
					<h3 class="list-heading location-panel-heading blue">Search Results</h3>
					<div class="tab-content">
						<div class="tab-pane active page-quick-sidebar-chat scrollable">
							<div class="page-quick-sidebar-chat-users" data-rail-color="#ddd" data-wrapper-class="page-quick-sidebar-list">
								<ul class="media-list list-items">
									<li class="media" v-for="location in locationSearchResults" @click="setActiveLocation(location)">
										<div class="media-body">
											<h4 class="media-heading">{{location.location_name}}</h4>
											<div class="media-heading-sub">{{location.location_address}}</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="padding-box" v-if="locationSearchError.length">
						<div class="alert alert-danger">
							<button class="close" data-close="alert" @click="clearSearchError('location')"></button>
						    <span>{{locationSearchError}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { debounce } from 'lodash'
import LoadingScreen from './modules/LoadingScreen'
import Business from '../controllers/Business'
import Location from '../controllers/Location'
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'app-side-panel',
	data () {
		return {
			locationSearch: {
				search: ''
			},
			businessSearch: {
				search: ''
			},
			locationSearchResults: [],
			businessSearchResults: [],
			locationSearchError: '',
			businessSearchError: '',
			loadingBusinessData: false,
			loadingLocationData: false
		}
	},
	/**
	 * Run on `created` to initialize the debounce events.
	 * @function
	 * @returns {undefined}
	 * @memberof AppSidePanel
	 * @version 0.0.7
	 */
	created () {
		this.debouncedBusinessSearch = debounce(() => {
			this.getBusinessSearchResults()
		}, 500)

		this.debouncedLocationSearch = debounce(() => {
			this.getLocationSearchResults()
		}, 500)
	},
	computed: mapGetters([
		'unoappAccount',
		'businessAccount',
		'activeBusinessId',
		'activeBusinessName',
		'activeLocationId',
		'activeLocationName'
	]),
	methods: {
		/**
		 * To clear the search field.
		 * @function
		 * @param {string} type - The error message to be cleared.
		 * @returns {undefined}
		 * @memberof AppSidePanel
		 * @version 0.0.7
		 */
		clearSearch (type) {
			if (type === 'location') {
				this.locationSearchResults = []
				this.locationSearch.search = ''
			} else if (type === 'business') {
				this.businessSearchResults = []
				this.businessSearch.search = ''
			}
		},
		/**
		 * To clear the current error.
		 * @function
		 * @param {string} type - The error message to be cleared.
		 * @returns {undefined}
		 * @memberof AppSidePanel
		 * @version 0.0.7
		 */
		clearSearchError (type) {
			if (type === 'location') {
				this.locationSearchError = ''
			} else if (type === 'business') {
				this.businessSearchError = ''
			}
		},
		/**
		 * To get the list of businesses based on the search field.
		 * @function
		 * @returns {undefined}
		 * @memberof AppSidePanel
		 * @version 0.0.7
		 */
		getBusinessSearchResults () {
			let _this = this

			if (this.businessSearch.search.length >= 3) {
				let searchCriteria = {
					search_query: this.businessSearch.search,
					search_in: 'business_name'
				}
				let sortCriteria = {
					sort_by: 'business_name',
					sort_order: 'asc'
				}

				this.clearSearchError('business')
				this.loadingBusinessData = true
				Business.getBusinesses(1, 25, searchCriteria, sortCriteria).then(response => {
					setTimeout(() => {
						_this.businessSearchResults = response.payload.businesses
						_this.loadingBusinessData = false
					}, 200)
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
						case 'no_businesses_found':
							_this.loadingBusinessData = false
							_this.businessSearchError = 'There are no matching records. Please try again.'
							break
						default:
							// No default
						}
					}
				}))
			} else if (this.businessSearch.search.length) {
				this.businessSearchResults = []
				this.businessSearchError = 'In order to use the search field your term must be at least 3 characters.'
			} else {
				this.businessSearchResults = []
			}
		},
		/**
		 * To set the active business.
		 * @function
		 * @param {object} business - The business to be set as active.
		 * @returns {undefined}
		 * @memberof AppSidePanel
		 * @version 0.0.9
		 */
		setActiveBusiness (business) {
			this.setActiveBusinessId(business.business_id)
			this.setActiveBusinessName(business.business_name)
			// store the business_id in localStorage
			/* eslint-disable no-undef */
			localStorage.setItem('activeBusiness', JSON.stringify(business))

			this.clearSearch('business')
		},
		/**
		 * To set the active location.
		 * @function
		 * @param {object} location - The location to be set as active.
		 * @returns {undefined}
		 * @memberof AppSidePanel
		 * @version 0.0.9
		 */
		setActiveLocation (location) {
			this.setActiveLocationId(location.location_id)
			this.setActiveLocationName(location.location_name)
			// store the location_id in localStorage
			/* eslint-disable no-undef */
			localStorage.setItem('activeLocation', JSON.stringify(location))

			this.clearSearch('location')
		},
		/**
		 * To get business locations for the current page.
		 * @function
		 * @returns {undefined}
		 * @memberof AppSidePanel
		 * @version 0.0.9
		 */
		getLocationSearchResults () {
			let _this = this

			if (this.locationSearch.search.length >= 3) {
				const pageNumber = 1
				const pageResults = 25
				const businessId = this.activeBusinessId
				let searchCriteria = {
					search_query: this.locationSearch.search,
					search_in: 'name'
				}
				let sortCriteria = {
					sort_by: 'name',
					sort_order: 'asc'
				}

				this.clearSearchError('location')
				this.loadingLocationData = true
				return Location.getLocations(businessId, pageNumber, pageResults, searchCriteria, sortCriteria).then(response => {
					_this.locationSearchResults = response.payload.locations
					_this.loadingLocationData = false
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
						case 'locations_not_found':
							_this.loadingLocationData = false
							_this.locationSearchError = 'There are no matching records. Please try again.'
							break
						default:
							// No default
						}
					}
				}))
			} else if (this.locationSearch.search.length) {
				this.locationSearchResults = []
				this.locationSearchError = 'In order to use the search field your term must be at least 3 characters.'
			} else {
				this.locationSearchResults = []
			}
		},
		/**
		 * To clear the selected location and select the business instead.
		 * @function
		 * @returns {undefined}
		 * @memberof AppSidePanel
		 * @version 0.0.9
		 */
		selectMasterAccount () {
			this.clearActiveLocation()
			this.clearSearch('location')
			this.clearSearchError('location')
		},
		/**
		 * To clear the selected location and business and select the UNOapp master account.
		 * @function
		 * @returns {undefined}
		 * @memberof AppSidePanel
		 * @version 0.0.9
		 */
		selectMasterUNOappAccount () {
			this.clearActiveLocation()
			this.clearSearch('location')
			this.clearSearchError('location')
			this.clearActiveBusiness()
			this.clearSearch('business')
			this.clearSearchError('business')
		},
		...mapActions([
			'setActiveBusinessId',
			'setActiveBusinessName',
			'clearActiveBusiness',
			'setActiveLocationId',
			'setActiveLocationName',
			'clearActiveLocation'
		])
	},
	components: {
		LoadingScreen
	},
	watch: {
		/**
		 * Watch `businessSearch.search` so that we can do a backend typeahead search.
		 * @function
		 * @returns {undefined}
		 * @memberof AppSidePanel
		 * @version 0.0.7
		 */
		'businessSearch.search' () {
			this.debouncedBusinessSearch()
		},
		/**
		 * Watch `locationSearch.search` so that we can do a backend typeahead search.
		 * @function
		 * @returns {undefined}
		 * @memberof AppSidePanel
		 * @version 0.0.9
		 */
		'locationSearch.search' () {
			this.debouncedLocationSearch()
		}
	}
}
</script>
<style>
.floating-tab-button {
	position: absolute;
    top: 17px;
    left: 15px;
    font-size: 11px;
    text-transform: uppercase;
    color: #657b8d;
    cursor: pointer;
}
.floating-tab-button:hover {
	text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// AppSidePanel.vue?1e430b3b